import type {ListLeadsSearch} from "./-types";

import {listLeadsQueryOptions} from "@project/application/sales/leads";
import {AppErrorBoundary} from "@project/layouts";
import {createFileRoute} from "@tanstack/react-router";

import {LeadsPage} from "./-page/leads.page";
import {LeadsPending} from "./-page/leads.pending";
import {listLeadsSearchSchema} from "./-types";

export type {ListLeadsSearch} from "./-types";

export const Route = createFileRoute("/_app/sales/leads/")({
  component: LeadsPage,
  errorComponent: AppErrorBoundary,
  loader: async ({context: {queryClient}, deps, cause}) => {
    if (cause === "enter") {
      return queryClient.ensureQueryData(listLeadsQueryOptions(deps as ListLeadsSearch));
    }

    void queryClient.prefetchQuery(listLeadsQueryOptions(deps as ListLeadsSearch));

    return;
  },
  loaderDeps: ({search}) => search,
  pendingComponent: LeadsPending,
  staticData: {meta: {breadcrumbs: {hide: true}}},
  validateSearch: (search) => listLeadsSearchSchema.parse(search),
});
